$(document).on("keyup",".cart-attribute__field input, .cart-attribute__field textarea",function() {
  check_validation();
});
$(document).on("click",".cart-attribute__field input[type='radio']",function() {
  check_validation();
});
function check_validation() {
  let isValid = true;

  let date = $(".cart-attribute__field input#date").val().trim();
  let textarea_personal_message = $(".cart-attribute__field textarea#add-a-personal-message-no-longer-than-200-characters").val().trim();
  let textarea_personal_message2 = $(".cart-attribute__field textarea#special-delivery-instructions-br-eg-business-name-leave-with-reception").val().trim();
  let radio_checked = $('.cart-attribute__field input[type="radio"]:checked').val();
  let phone_number = $('.cart-attribute__field #phone-number').val();

  if (date == "") {
    isValid = false;
  }
  // if (textarea_personal_message == "") {
  //   isValid = false;
  // }
  // if (textarea_personal_message2 == "") {
  //   isValid = false;
  // }
  if (radio_checked == undefined) {
    isValid = false;
  }
  if (phone_number == "") {
    isValid = false;
  }

  debugger
  let combinedValues = `
    Date: ${date}
    Personal Message: ${textarea_personal_message}
    Special Delivery Instructions: ${textarea_personal_message2}
    Permission to leave on doorstep: ${radio_checked}
    Phone Number: ${phone_number}
  `;
  $('.cart__note .text-area').val('')
  
  if (isValid) {
    $('.cart__note .text-area').val(combinedValues)
    $('.cart__checkout-button').removeAttr("disabled");
  }else{
    $('.cart__checkout-button').attr("disabled","true");
  }

  
}